
import { Vue, Component } from 'vue-property-decorator';
import { i18n } from '@/i18n';
import BillingDetail from '@/Pages/AccountPage/BillingDetail/BillingDetail.vue';
import { User } from '@/classes/auth';

@Component({
  components: { BillingDetail },
})
export default class Account extends Vue {
  user: User = new User();
  activeTab?: any = '/my-account';
  tabs: Array<{ id: number; key: string; title: string; route: string }> = [
    {
      id: 1,
      key: 'account',
      title: i18n.t('fields.account.tabs.account_tab').toString(),
      route: '/my-account',
    },
    {
      id: 2,
      key: 'user_management',
      title: i18n.t('fields.account.tabs.user_management_tab').toString(),
      route: '/my-account/user-management',
    },
    {
      id: 3,
      key: 'white_label',
      title: i18n.t('fields.account.tabs.white_label_tab').toString(),
      route: '/my-account/white-label',
    },
    {
      id: 4,
      key: 'api_keys',
      title: i18n.t('fields.account.tabs.api_keys_tab').toString(),
      route: '/my-account/api-keys',
    },
    {
      id: 5,
      key: 'billing',
      title: i18n.t('fields.account.tabs.billing_tab').toString(),
      route: '/my-account/billing',
    },
  ];

  created(): void {
    this.activeTab = this.$route.path;
  }

  get activeTabTitle(): string {
    try {
      if (this.tabs.length) {
        return this.tabs.find((element) => element.route === this.activeTab)!.title;
      }
      return '';
    } catch (e) {
      return 'n/a';
    }
  }
}
